/*
 * @Author: Scarlett Xiao
 * @Date: 2022-03-16 11:07:39
 * @LastEditors: Scarlett Xiao
 * @LastEditTime: 2022-03-16 17:07:36
 */

/**
 * @brief: 判断字符是否为汉字
 * @author: Scarlett Xiao
 * @Date: 2021-11-02 15:31:47
 * @param {*} s
 */
export function isChinese(s) {
  return /[\u4e00-\u9fa5]/.test(s);
}
/**
 * @brief: 把字符串中的汉字转换成Unicode
 * @author: Scarlett Xiao
 * @Date: 2021-11-02 15:31:36
 * @param {*} str
 */
export function ch2Unicdoe(str) {
  if (!str) {
    return;
  }
  let unicode = '';
  for (let i = 0; i < str.length; i++) {
    const temp = str.charAt(i);
    if (this.isChinese(temp)) {
      unicode += '\\u' + temp.charCodeAt(0).toString(16);
    } else {
      unicode += temp;
    }
  }
  return unicode;
}

//  str = 'love中国你好';
// console.info(ch2Unicdoe(str))    //  love\u4e2d\u56fd\u4f60\u597d

/**
 * @brief: 遍历字符串unicode转汉字
 * @author: Scarlett Xiao
 * @Date: 2021-11-02 15:31:11
 * @param {*} str
 */
export function unicode2Ch(str) {
  if (!str) {
    return;
  }
  // 控制循环跃迁
  let len = 1;
  let result = '';
  // 注意，这里循环变量的变化是i=i+len 了
  for (let i = 0; i < str.length; i = i + len) {
    len = 1;
    const temp = str.charAt(i);
    if (temp === '\\') {
      // 找到形如 \u 的字符序列
      if (str.charAt(i + 1) === 'u') {
        // 提取从i+2开始(包括)的 四个字符
        const unicode = str.substr((i + 2), 4);
        const num = parseInt(unicode, 16).toString(10);
        // 以16进制为基数解析unicode字符串，得到一个10进制的数字
        result += String.fromCharCode(num);
        // 提取这个unicode经过了5个字符， 去掉这5次循环
        len = 6;
      } else {
        result += temp;
      }
    } else {
      result += temp;
    }
  }
  return result;
}

// console.info("unicode2Ch:"+ unicode2Ch("love\u4e2d\u56fd1234\u4f60\u597d")) //love中国1234你好